<template>
  <!-- 评课 -->
  <div class="course">
    <div v-if="formInfo" class="course-main" :class="{isFull}">
      <div class="head">
        <div class="top">
          <div>评课</div>
          <div
            v-if="!isFull && (activeInfo.videoList.length || activeInfo.eventOtherInfo.eventOtherInfoLiveRoomId == '1')"
            class="head-tab-container"
          >
            <ul class="head-tab">
              <li @click="changeTab(1)" :class="{active: video.isLive}">直播</li>
              <li @click="changeTab(2)" :class="{active: !video.isLive}">录像</li>
            </ul>
          </div>
          <div class="head-tab-container">
            <van-checkbox style="justify-content: center;" v-if="isFull" v-model="autoFull" shape="square"
              ><span style="color:#909399">以后表单自动全屏</span></van-checkbox
            >
          </div>
          <img @click="isFull = true" v-if="!isFull" src="@/assets/image/full.png" style="width:20px" alt="" />
          <img @click="isFull = false" v-else src="@/assets/image/no-full.png" style="width:20px" alt="" />
          <i
            @click="hanldeCance"
            style="color:#909399;font-size: 20px;margin-left:10px"
            class="iconfont icon-close"
          ></i>
        </div>
        <div class="title van-ellipsis">{{ formInfo.formName }}</div>
      </div>
      <formCreate :formOptions="formInfo.formInfo" />
      <circle-btn @click.native="handle2Submit" class="submit-btn">提交</circle-btn>
    </div>
    <circle-btn v-if="courseList.length != 0" @click.native="handle2Course" class="course-btn">评课</circle-btn>
    <van-action-sheet v-model="show" title="请选择评课表" :closeable="false">
      <div class="course-item-container">
        <div
          class="course-item van-ellipsis"
          @click="selectCourse(item)"
          v-for="(item, index) in courseList"
          :key="index"
        >
          {{ item.name }}
          <span v-if="item.status === 2">已参与</span>
        </div>
      </div>
    </van-action-sheet>

    <van-action-sheet v-model="showVideos" title="请选择录像" :closeable="false">
      <div class="course-item-container">
        <div
          class="course-item van-ellipsis"
          @click="selectVideo(item)"
          v-for="(item, index) in activeInfo.videoList"
          :key="index"
        >
          {{ item.eventAttrName }}
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import {formGetOneData, formsaveAnswer, getAllEventBarrageInfo} from '@/api'
import formCreate from './formCreate'
export default {
  components: {
    formCreate
  },
  data() {
    return {
      id: this.$route.params.id,
      courseItem: null,
      formInfo: null,
      show: false,
      showVideos: false,

      isFull: false,
      autoFull: false
    }
  },
  watch: {
    autoFull(val) {
      localStorage.setItem('autoFull', JSON.stringify(val))
    },
    formInfo(val) {
      this.isFull = JSON.parse(localStorage.getItem('autoFull')) || false
      this.autoFull = JSON.parse(localStorage.getItem('autoFull')) || false
    }
  },
  computed: {
    activeInfo() {
      return this.$store.state.activePlay.activeInfo
    },
    video() {
      return this.$store.state.activePlay.video
    },
    setReport() {
      return this.$store.state.activePlay.report
    },
    courseList() {
      return this.$store.state.activePlay.courseList
    }
  },
  mounted() {
    this.$store.dispatch('getCourseList', this.id)
  },
  methods: {
    async selectVideo(item) {
      const params = {
        eventAttrId: item.eventAttrId,
        eventInfoId: this.id
      }
      const result = await getAllEventBarrageInfo(params)
      item.barrageList = result.data
      item.eventAttrPath = this.$isCdn(item.eventAttrPath)
      this.$parent.previewVideo(item)
      this.$store.commit('setVideoDanmuSet', {attrId: item.eventAttrId})
      this.showVideos = false
    },
    changeTab(tab) {
      if (tab === 1) {
        if (this.video.isLive) {
          return false
        }
        this.$parent.changeTab(0)
      } else {
        if (!this.video.isLive) {
          return false
        }
        /* 显示video */
        if (this.activeInfo.videoList.length === 0) {
          this.$Toast.fail('暂无录像')
        } else {
          this.showVideos = true
        }
      }
      const liveBullet = document.querySelector('.liveBullet')
      const videoBullet = document.querySelector('.videoBullet')
      videoBullet.innerHTML = ''
      liveBullet.innerHTML = ''
    },
    handle2Course() {
      if (this.courseList.length === 1) {
        this.selectCourse(this.courseList[0])
      } else {
        this.show = true
      }
    },
    selectCourse(item) {
      this.courseItem = item
      if (this.courseItem.status === 2) {
        /* 已经参与了 */
        this.handle2LookReport()
      } else {
        this.handle2Getform()
      }
    },
    /* 获取表单 */
    handle2Getform() {
      this.show = false
      formGetOneData(this.courseItem.formTemplateInfoId).then(res => {
        this.formInfo = res.data
      })
    },
    handle2Submit() {
      this.$dialog
        .confirm({
          message: '确认提交?',
          confirmButtonColor: '#4465f3'
        })
        .then(() => {
          const formInfoId = this.courseItem.formInfoId
          formsaveAnswer(formInfoId, this.setReport).then(res => {
            if (res.code === 0) {
              /* 初始化状态 */
              this.$store.commit('resetReport')
              this.$router.push(`/courseSuccess?formInfoId=${formInfoId}&eventId=${this.id}`)
            }
          })
        })
    },
    hanldeCance() {
      this.$dialog
        .confirm({
          message: '确认退出?',
          confirmButtonColor: '#4465f3'
        })
        .then(() => {
          this.$store.commit('resetReport')
          this.formInfo = null
          this.courseItem = null
        })
    },
    handle2LookReport() {
      const formInfoId = this.courseItem.formInfoId
      this.$router.push(`/courseReport?formInfoId=${formInfoId}&eventId=${this.id}`)
    }
  }
}
</script>

<style scoped lang="scss">
.course-main {
  overflow-y: scroll;
  position: absolute;
  z-index: 100;
  &.isFull {
    top: 0;
  }
  top: 220px;
  left: 0;
  right: 0;
  bottom: 0;
  background: #f8f9fb;
  .head {
    padding: 10px 10px;
    background: #fff;
  }
  .head .title {
    font-weight: bold;
    line-height: 2;
  }
  .top {
    display: flex;
    align-items: center;
    .head-tab-container {
      flex: 1;
    }
    .head-tab {
      margin-left: 10px;
      width: 100px;
      background: #f4f6f9;
      border-radius: 22px;
      position: relative;
      li {
        display: inline-block;
        width: 50%;
        padding: 4px 0;
        padding: 2px 0;
        color: #606266;
        font-size: 14px;
        text-align: center;
      }
      li.active {
        color: #fff;
        background: #4a86f6;
        border-radius: 10px;
      }
    }
  }
}
.course-btn {
  position: absolute;
  z-index: 96;
  right: 20px;
  bottom: 16%;
}
.submit-btn {
  position: fixed;
  right: 20px;
  bottom: 10%;
}

.course-item-container {
  max-height: 40vh;
  overflow-y: scroll;
}
.course-item {
  text-align: center;
  padding: 20px 15%;
  border-top: 1px solid #eee;
  position: relative;
  span {
    position: absolute;
    right: 20px;
    top: 50%;
    font-size: 12px;
    transform: translateY(-50%);
    padding: 2px;
    background: rgba(76, 132, 255, 0.24);
    color: #4c84ff;
    border-radius: 4px;
  }
}
</style>
